import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const Container = styled.div<{ $variant: 'default' | 'compact' | 'preview' }>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ $variant }) => ($variant === 'compact' ? '2px' : '4px')};
  align-items: center;
`

export const TagItem = styled.div<{
  $variant: 'default' | 'compact' | 'preview'
  $isCounter?: boolean
  $fullText?: boolean
}>`
  display: flex;
  align-items: center;
  padding: ${({ $variant }) => {
    switch ($variant) {
      case 'compact':
        return '3px 6px'
      case 'preview':
        return '2px 6px'
      default:
        return '4px 8px'
    }
  }};
  background-color: ${({ $isCounter }) => ($isCounter ? Tokens.ColorTextSecondary : Tokens.ColorUIPrimaryLight)};
  color: ${({ $isCounter }) => ($isCounter ? Tokens.ColorWhite : Tokens.ColorTextPrimary)};
  border-radius: ${({ $variant }) => ($variant === 'compact' ? '4px' : '4px')};
  font-size: ${({ $variant }) => {
    switch ($variant) {
      case 'compact':
        return '12px'
      case 'preview':
        return '12px'
      default:
        return '14px'
    }
  }};
  font-weight: 500;
  border: 1px solid ${({ $isCounter }) => ($isCounter ? Tokens.ColorTextSecondary : 'transparent')};

  ${({ $fullText }) =>
    $fullText ?
      `
    max-width: none;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  `
    : `
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.7;
  flex-shrink: 0;

  &:hover {
    opacity: 1;
  }
`

export const TagText = styled.span<{ $fullText?: boolean }>`
  max-width: 100%;

  ${({ $fullText }) =>
    $fullText ?
      `
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  `
    : `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`

export const NoTagsText = styled.span`
  font-size: 11px;
  color: ${Tokens.ColorTextSecondary};
  font-style: italic;
`

export const MoreTagsIndicator = styled.div<{ $variant: 'default' | 'compact' | 'preview' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $variant }) => {
    switch ($variant) {
      case 'compact':
        return '3px 6px'
      case 'preview':
        return '2px 6px'
      default:
        return '4px 8px'
    }
  }};
  background-color: ${Tokens.ColorUIPrimaryLight};
  color: ${Tokens.ColorTextPrimary};
  border-radius: ${({ $variant }) => ($variant === 'compact' ? '4px' : '4px')};
  font-size: ${({ $variant }) => {
    switch ($variant) {
      case 'compact':
        return '12px'
      case 'preview':
        return '12px'
      default:
        return '14px'
    }
  }};
  font-weight: 600;
  min-width: ${({ $variant }) => ($variant === 'compact' ? '24px' : '28px')};
  height: ${({ $variant }) => {
    switch ($variant) {
      case 'compact':
        return '20px'
      case 'preview':
        return '20px'
      default:
        return '24px'
    }
  }};
  cursor: help;
  border: 1px solid transparent;
  transition: all 0.2s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: ${Tokens.ColorUIPrimary};
    color: ${Tokens.ColorWhite};
    transform: scale(1.05);
  }
`
